export const getIconFromName = (name: string | undefined): string => {
  if (name) {
    let iconName = '';
    const nameSplited = name.trim().split(' ').slice(0, 2);

    nameSplited.forEach((shortName) => {
      iconName += shortName[0];
    });

    return iconName;
  }

  return 'NN';
};
